import { render, staticRenderFns } from "./diamond.vue?vue&type=template&id=10dad2d6&"
import script from "./diamond.vue?vue&type=script&lang=js&"
export * from "./diamond.vue?vue&type=script&lang=js&"
import style0 from "./diamond.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports